import { TripAnnotation } from "@fairfleet/geotab";
import { isWithinInterval } from "date-fns";
import sortBy from "lodash/sortBy";
import { tripInterval } from "../../trip/tripInterval";
import { TripRef } from "../../trip/TripRef";

/** A trip with the associated {@link TripAnnotation}s. */
export interface TripWithAnnotations extends TripRef {
  /**
   * The annotations for the {@link Trip}.
   */
  annotations: TripAnnotation[];
}

/**
 * Returns an {@link Iterable} yielding {@link TripWithAnnotations} for each {@link Trip} in the
 * provided array of trips with their associated {@link TripAnnotation}.
 *
 * @param trips - The {@link Trip} to link annotations to.
 * @param annotations - The {@link TripAnnotation}s to link.
 */
export default function* getTripsWithAnnotations(
  trips: Iterable<TripRef>,
  annotations: TripAnnotation[],
) {
  annotations = sortBy(annotations, a => a.dateTime);

  for (const trip of trips) {
    const interval = tripInterval(trip);

    yield {
      ...trip,
      annotations: annotations.filter(annotation =>
        isWithinInterval(annotation.dateTime, interval),
      ),
    } as TripWithAnnotations;
  }
}
